// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Добавить стили при необходимости */", "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA,qCAAqC","sourcesContent":["/* Добавить стили при необходимости */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
